module.exports = __webpack_public_path__ + "static/media/logo1.ccd3e04e.png";